import React from 'react'
import analytics from './src/utils/analytics'
import SiteUtilities from './src/components/site-utilities'

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <SiteUtilities />
  </>
)

export const onRouteUpdate = async ({ location }) => {
  const { language, userAgent } = window.navigator
  const { name } = location
  const properties = {
    language,
    userAgent
  }

  return analytics.page(name || document.title, { properties })
}
